// Taille maximum autorisée pour les fichiers joints, en Mo
export const MAX_UPLOAD_FILESIZE = 25;

export const MAX_UPLOAD_FILESIZE_BYTES = MAX_UPLOAD_FILESIZE * 1024 * 1024;

export const MAX_UPLOAD_NUMBER_FILES = 25;

export enum FileFormats {
  TEXT = 'text/plain',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  PNG = 'image/png',
  PDF = 'application/pdf',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
}

export const ALLOWED_FILE_TYPES: FileFormats[] = [
  FileFormats.TEXT, // Fichiers texte
  FileFormats.JPEG, // Images JPEG
  FileFormats.JPG, // Images JPG
  FileFormats.PNG, // Images PNG
  FileFormats.PDF, // Fichiers .pdf
  FileFormats.DOC, // Microsoft Word .doc
  FileFormats.DOCX, // Microsoft Word (OpenXML) .docx
];

export const ALLOWED_FILE_EXTENSIONS = [
  'pdf',
  'jpg',
  'png',
  'doc',
  'docx',
  'txt',
];
